(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('QueueDialogController', QueueDialogController);


    QueueDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Queue', 'QueueStatus', 'QueueType', 'User'];

    function QueueDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Queue, QueueStatus, QueueType, User) {

        var vm = this;

        vm.queue = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        vm.queue_statuses = QueueStatus.query();
        vm.queue_types = QueueType.query();
        vm.jhi_users = User.query();


        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.queue.id !== null) {
                Queue.update(vm.queue, onSaveSuccess, onSaveError);
            } else {
                Queue.save(vm.queue, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('doctorclubboApp:queueUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.dtIns = false;
        vm.datePickerOpenStatus.dtUpdate = false;
        vm.datePickerOpenStatus.dtFirstExecution = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
